var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Content',{class:{ 'headline-gradient': _vm.hasGradient },attrs:{"data-tour-step":"headline","item":_vm.item,"parent":_vm.parent}})}
var staticRenderFns = []

export { render, staticRenderFns }